var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"no-gutter":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" Copyright ⓒ BusinessOn Communication Co., Ltd. All rights reserved. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }